
import { FC, useEffect, useState } from 'react';
import { getInitialProps, useTranslation } from 'react-i18next';
import '../styles/components/alarmPopup.css';
import Notice from './layout/Notice';
import Inquiry from './layout/Inquiry';
import CommonAlarmLine from './layout/CommonAlarm';


type AlarmType = {
  id: string | number;
  type: string;
  title: string;
  date: string;
  link: string;
}

interface IProps {
    data: any;
    execute: any;
    execute4: any;
    isVisible: boolean;
}


const AlarmPopup: FC<IProps> = ({
    data,
    execute,
    execute4,
    isVisible
  }) => {
    const { t } = useTranslation();

  return (
    
    <div className={`alarm-popup-menu dropdown-menu-lg dropdown-menu-right ${isVisible ? 'show' : ''}`} >
      <div className='alarm-popup-wrap'>
        { data &&
            Object.entries(data).map(([key, v]) => {
            return (
                <dl>
                    <dt>{key}</dt>
                    {data[key].map((item: any)=> {
                      if(item.alarmType === 'notice') {
                        return ( <Notice key={item} data={item} execute={execute}/> );
                      } else if(item.alarmType === 'inquiry') {
                        return ( <Inquiry key={item} data={item} execute={execute4}/> );
                      } else if(item.alarmType === 'expense') {
                        return (<CommonAlarmLine key={item} data={item} badgeName={t('payment.expense.btn6')} goToUrl='/payment/financial?type=3' />);
                      }
                    })}
                </dl>
            )
            })
        }
      </div>
  </div>
  );
}

export default AlarmPopup;
